export default "__VITE_ASSET__wR$aE6dB__"